<aside class="chat-panel" [class.chat-panel--open]="isOpen">
  <div class="chat-panel__header">
    <div class="chat-panel__history" (click)="$event.stopPropagation()">
      <button
        type="button"
        class="chat-panel__title-btn"
        (click)="toggleHistory()"
        [attr.aria-expanded]="isHistoryOpen"
        aria-haspopup="true"
      >
        <span class="chat-panel__title">{{ title || 'Nova Conversa' }}</span>
        <i class="fas fa-chevron-down chat-panel__caret"></i>
      </button>

      <div class="chat-panel__dropdown" *ngIf="isHistoryOpen">
        <button
          type="button"
          class="chat-panel__dropdown-action"
          (click)="startNewChat()"
        >
          <i class="fas fa-plus"></i>
          <span>Nova conversa</span>
        </button>

        <div class="chat-panel__dropdown-divider"></div>

        <div class="chat-panel__dropdown-list">
          <p class="chat-panel__dropdown-empty" *ngIf="!conversations.length">
            Nenhuma conversa ainda
          </p>
          <button
            *ngFor="let item of conversations; trackBy: trackBySessionId"
            type="button"
            class="chat-panel__dropdown-item"
            [class.chat-panel__dropdown-item--active]="item.id === sessionId"
            (click)="selectConversation(item)"
            [title]="item.title || 'Nova conversa'"
          >
            <i
              class="fas fa-thumbtack chat-panel__dropdown-pin"
              *ngIf="item.pinned"
            ></i>
            <span class="chat-panel__dropdown-item-text">{{
              item.title || 'Nova conversa'
            }}</span>
          </button>
        </div>
      </div>
    </div>

    <div class="chat-panel__header-actions">
      <button
        type="button"
        class="chat-panel__btn"
        (click)="openPreferences()"
        title="Preferências"
        aria-label="Preferências"
      >
        <i class="fas fa-cog"></i>
      </button>
      <button
        type="button"
        class="chat-panel__btn"
        (click)="openInFullPage()"
        [disabled]="creatingSession"
        title="Abrir em tela cheia"
        aria-label="Abrir em tela cheia"
      >
        <i class="fas fa-expand"></i>
      </button>
      <button
        type="button"
        class="chat-panel__btn"
        (click)="onClose()"
        title="Fechar"
        aria-label="Fechar"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>

  <div *ngIf="creationFailed" role="alert">
    Não foi possível iniciar a conversa. Sua mensagem foi preservada.
    <button type="button" (click)="retryPendingMessage()">
      Tentar novamente
    </button>
  </div>

  <sgt-chat-conversation
    variant="panel"
    [sessionId]="sessionId"
    [loadingHistory]="loadingHistory"
    inputPlaceholder="Pergunte alguma coisa ou peça uma ação..."
    (messageSent)="onMessageSent($event)"
  >
    <div chat-welcome class="chat-panel__welcome" *ngIf="!loadingTopics || information">
      <div class="chat-panel__welcome-header">
        <img
          class="chat-panel__sparkle"
          src="assets/img/ceppem-ai-sparkle.svg"
          alt=""
        />
        <p class="chat-panel__greeting">{{ greeting }}</p>
        <p class="chat-panel__welcome-subtitle" *ngIf="!information">Como posso te ajudar hoje?</p>
        <p class="chat-panel__welcome-subtitle" *ngIf="information">
          Pergunte sobre o resultado selecionado. A AyA explica o que os números mostram sobre a sua carteira.
        </p>
      </div>

      <ng-container *ngIf="information; else contextTopics">
        <p class="chat-panel__section-label">Perguntas sobre este resultado</p>

        <sgt-chat-suggestions
          *ngIf="!topicsError"
          [topics]="topics"
          [loading]="loadingTopics"
          [skeletonCount]="4"
          (topicSelected)="onTopicSelected($event)"
        ></sgt-chat-suggestions>

        <p class="chat-panel__empty-text" *ngIf="topicsError">
          Não foi possível gerar perguntas sobre este resultado.
          <button type="button" class="chat-panel__link" (click)="retryTopics()">Tentar novamente</button>
        </p>
      </ng-container>

      <ng-template #contextTopics>
        <sgt-chat-suggestions
          *ngIf="topics.length"
          [topics]="topics"
          (topicSelected)="onTopicSelected($event)"
        ></sgt-chat-suggestions>

        <p class="chat-panel__empty-text" *ngIf="!topics.length">
          Pergunte qualquer coisa para começar.
        </p>
      </ng-template>
    </div>

    <sgt-information-chip
      chat-input-top
      *ngIf="information"
      [information]="information"
      (removed)="onInformationRemoved()"
    ></sgt-information-chip>
  </sgt-chat-conversation>
</aside>
